//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed } from '@vue/composition-api'
import {
  mdiTrayArrowUp,
  mdiCashCheck,
  mdiAccountRemoveOutline,
  mdiChevronDown,
} from '@mdi/js'
import { useUtils } from '@core/libs/i18n'

export default {
  name: 'PlayerAction',
  props: {
    showRemove: {
      type: Boolean,
      default: false,
    },
    showLeave: {
      type: Boolean,
      default: false,
    },
    showAdd: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { t } = useUtils()
    const actionsComputed = computed(() => [
      { text: '', action: '' },
    ])

    return {
      // computed
      actionsComputed,

      // i18n
      t,

      icons: {
        mdiTrayArrowUp,
        mdiCashCheck,
        mdiAccountRemoveOutline,
        mdiChevronDown,
      },
    }
  },
}
